import { Box, Container, Group, useMatches } from "@mantine/core";

import classes from "./Header.module.css";
import { HeaderNavLink } from "./components";

import type { MantineStyleProps } from "@mantine/core";
import type { FC, ReactNode } from "react";
import type { NavLinkItem } from "./components";

export type HeaderProps = {
  menu: NavLinkItem[];
  leftSection?: ReactNode;
  rightSection?: ReactNode;
} & MantineStyleProps;

type HeaderComponent = FC<HeaderProps> & {
  NavLink: typeof HeaderNavLink;
};

const HeaderContainer: HeaderComponent = ({ leftSection, menu, rightSection, ...props }) => {
  const matches = useMatches({ md: true });

  const isMobile = matches;

  return (
    <Box className={classes.background} h="100%">
      <Container {...props} h="100%" size="xl" px="xl">
        <Group justify="space-between" align="center" h="100%">
          <Group gap="xl" align="center">
            {leftSection}
            {isMobile ? (
              <Group>
                {menu
                  .filter((item) => !item.hide)
                  .map((item, index) => (
                    <HeaderNavLink key={index} {...item} size="sm" />
                  ))}
              </Group>
            ) : null}
          </Group>
          {rightSection}
        </Group>
      </Container>
    </Box>
  );
};

HeaderContainer.NavLink = HeaderNavLink;

export const Header = HeaderContainer;
